import Vue from 'vue'
import VueRouter from 'vue-router'
import { Toast } from 'vant'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Home from '../views/Home.vue'
import Flow from '../views/Flow.vue'
import Commission from '../views/Commission.vue'
import Team from '../views/Team.vue'
import Invite from '../views/Invite.vue'
import About from '../views/About.vue'
import Feedback from '../views/Feedback.vue'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'hash',
  routes: [
    { path: '/login', component: Login },
    { path: '/register', component: Register },
    { path: '/', component: Home },
    { path: '/consume', component: Flow, meta: { kind: 'consume', title: '消费明细' } },
    { path: '/points', component: Flow, meta: { kind: 'points', title: '积分明细' } },
    { path: '/exchange', component: Flow, meta: { kind: 'exchange', title: '兑换值明细' } },
    { path: '/commission', component: Commission },
    { path: '/team', component: Team },
    { path: '/invite', component: Invite },
    { path: '/about', component: About },
    { path: '/feedback', component: Feedback }
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('h5_token')
  if (to.path === '/register' && token) {
    Toast('你已是会员')
    next('/')
    return
  }
  if (!token && to.path !== '/login' && to.path !== '/register') {
    next('/login')
    return
  }
  next()
})

export default router
